import { render, staticRenderFns } from "./ActionsForm.vue?vue&type=template&id=22324966&scoped=true&"
import script from "./ActionsForm.vue?vue&type=script&lang=js&"
export * from "./ActionsForm.vue?vue&type=script&lang=js&"
import style0 from "./ActionsForm.vue?vue&type=style&index=0&id=22324966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22324966",
  null
  
)

export default component.exports